import httpClient from "../../../shared/api/httpClient";

export const googleImportApi = {
  // Eventos da agenda principal do Google entre de e ate ("yyyy-MM-dd"), sem os criados
  // pelo MedStation. Sem Google conectado o backend responde 409 com a orientação.
  listEvents: ({ de, ate }) =>
    httpClient.get(`/api/v1/google-agenda/eventos?de=${de}&ate=${ate}`).then((r) => r.data.dados.eventos ?? []),

  // itens: [{ google_event_id, vinculo_id, data, hora_inicio, horas, valor }]. A resposta
  // traz { criados: [...], pulados: [{ google_event_id, data, motivo }] }.
  importShifts: (itens) => httpClient.post("/api/v1/plantoes/importar", { itens }).then((r) => r.data.dados),
};
